import TaxiCorporationPlanEntryBillingsDownloadRequest, {
  TaxiCorporationPlanEntryBillingsDownloadRequestQueryParams,
} from "./taxi-corporation-plan-entry-billings-download.request";

const createQueryParams = (
  request: TaxiCorporationPlanEntryBillingsDownloadRequest,
): TaxiCorporationPlanEntryBillingsDownloadRequestQueryParams => {
  return {
    billing_model: request.billingModel,
    cargo_order_human_id: request.cargoOrderHumanId,
    date_since: request.dateSince,
    date_to: request.dateTo,
    driver: request.driver,
    fleet_partner: request.fleetPartner,
    human_id: request.humanId,
    order: request.order,
  };
};

const taxiCorporationPlanEntryBillingsDownloadRequestFactory = {
  createQueryParams,
};

export default taxiCorporationPlanEntryBillingsDownloadRequestFactory;
